import { CoreInputValidatorsProvider } from 'core-input-validators';
import pl from './lang/pl';
import en from './lang/en';
import { coreLoginPanelIcons } from './CoreLoginPanelIcons';

export default class CoreLoginPanelProvider {
  public static mergeLocales(i18n: any): void {
    CoreInputValidatorsProvider.mergeLocales(i18n);
    i18n.mergeLocaleMessage('pl', pl);
    i18n.mergeLocaleMessage('en', en);
  }

  public static mergeIcons(icons: any): void {
    Object.assign(icons, coreLoginPanelIcons);
  }
}
